import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutEmailProfileLookup extends Layout {
    sourceEmailProfile: DataSource;
    tableEmailProfile: Table;
}
